import {useState, useEffect} from 'react';

import axios from "src/utils/axios";

// ----------------------------------------------------------------------

const fetchPimcoreOptionsValueLabel = async (uri) => {
  const listResponse = await axios.get(uri);
  return listResponse.data.list;
}
export default function useBasicDataFormOptions(setValue) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [mealTypeList, setMealTypeList] = useState([]);
  const [forHowManyPersonList, setForHowManyPersonList] = useState([]);
  const [timeConsumingList, setTimeConsumingList] = useState([]);

  useEffect(() => {
    const fetchOptions = async () => {
      setMealTypeList(await fetchPimcoreOptionsValueLabel('api/recipeCategory/list'));

      const forHowManyPersonResponseList = await fetchPimcoreOptionsValueLabel('api/selectOption/list/OBJECT/recipe/ForHowManyPerson');
      setForHowManyPersonList(forHowManyPersonResponseList);
      const defaultFowHowManyPersonEntity = forHowManyPersonResponseList.find(entity => entity.is_default);
      if (defaultFowHowManyPersonEntity && setValue) {
        setValue('for_how_many_person', defaultFowHowManyPersonEntity.value);
      }

      const timeConsumingResponseList = await fetchPimcoreOptionsValueLabel('api/selectOption/list/OBJECT/recipe/TimeConsuming');
      setTimeConsumingList(timeConsumingResponseList);
      const defaultTimeConsumingEntity = timeConsumingResponseList.find(entity => entity.is_default);
      if (defaultTimeConsumingEntity && setValue) {
        setValue('time_consuming', defaultTimeConsumingEntity.value);
      }

      setIsLoaded(true);
    }

    fetchOptions();
  }, [setValue]);

  return {
    isLoaded,
    mealTypeList,
    forHowManyPersonList,
    timeConsumingList,
  };
}
